import type { ReactNode } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import TriByArticleLine from "components/molecules/tables/TriByArticleLine";
import TriByArticleLineHeader from "components/molecules/tables/TriByArticleLineHeader";
import TriByArticleLineSkeleton from "components/molecules/tables/TriByArticleLineSkeleton";
import type CommandeArticleTri from "models/CommandeArticleTri";
import type { User } from "@sdeapps/react-core";
import { rangeUtil } from "utils/rangeUtil";

interface TriByArticleListProps {
  articles: Array<CommandeArticleTri>;
  agents: Array<User>;
  isLoading: boolean;
  onNumeroBonDeCommandeChange: (commandeArticle: CommandeArticleTri) => void;
}

function TriByArticleList({
  articles,
  agents,
  isLoading = false,
  onNumeroBonDeCommandeChange,
}: Readonly<TriByArticleListProps>): ReactNode {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  if (isSmallScreen) {
    return (
      <Typography>
        Cette page n'est disponible que pour les résolutions supérieures à{" "}
        {theme.breakpoints.values.md}px.
      </Typography>
    );
  }

  return (
    <TableContainer sx={{ width: "100%" }} component={Grid} size={12}>
      <Table size="small">
        <TriByArticleLineHeader />
        <TableBody>
          {!isLoading && articles.length === 0 && (
            <TableRow>
              <TableCell colSpan={9} align="center">
                <Typography>
                  Aucun article de commande ne correspond aux filtres sélectionnés
                </Typography>
              </TableCell>
            </TableRow>
          )}
          {isLoading
            ? rangeUtil.arrayRange(15).map((i) => <TriByArticleLineSkeleton key={i} />)
            : articles.map((article) => (
                <TriByArticleLine
                  key={`${article.commandeId}${article.commandeArticleNumber}`}
                  article={article}
                  agent={agents.find((a) => a.id === article.demandeurId)}
                  onNumeroBonDeCommandeChange={onNumeroBonDeCommandeChange}
                />
              ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
export default TriByArticleList;
